import React, { useEffect } from "react";

import Faq_Banner from "./faq-banner/Faq_Banner";
import ScrollToTop from "../scrolltotop/ScrollToTop";

const Faq = () => {


  return (
    <>
      <ScrollToTop />

      {/* FAQ Banner */}
      <div >
        <Faq_Banner />
      </div>
    </>
  );
};

export default Faq;